import {SpotLayer} from './SpotLayer.js';

var self;

var hoverSelectedName = '';
var hoverSelectedFeature = null;

//Create an overlay to anchor the popup to the map
const targetDiv = document.getElementById('popup');
const closeBtn = document.getElementById('popup-closer');
const popupContent = document.getElementById('popup-content');


export class MetroSPbLayer extends SpotLayer {
	constructor(options){
		options.source = new ol.source.Vector();

		super(options);
		self = this;
	

		const items = this.getItems();
		for (var item in items) {
			var marker = new ol.Feature({
				geometry: new ol.geom.Point(ol.proj.fromLonLat([items[item].lon, items[item].lat])),
				style: 'default',
				name: items[item].name,
			});
			var props = marker.getProperties();
			Object.assign(props, items[item]);
			//props.color = items[item].color;
			marker.setProperties(props);
			marker.styleFunc = this.styleFunc;
			marker.setStyle(this.styleFunc);
			this.getSource().addFeature(marker);
		}
		
		this.overlay = new ol.Overlay({
			element: targetDiv,
			autoPan: true,
			autoPanAnimation: {
				duration: 250
			},
		});
		
		closeBtn.addEventListener('click', self.clickUnset);
	}


	getItems(){
		const stations = `
			L.circleMarker([59.9304, 30.3608],Object.assign({color:"#ff0000",u:"line1/vosstania"},z)).addTo(map).on("click",cClk).bindTooltip("Площадь Восстания",{className:"line2746f"});
			L.circleMarker([59.8419, 30.2535],Object.assign({color:"#eb1b07",u:"line1/veteranov"},z)).addTo(map).on("click",cClk).bindTooltip("Проспект Ветеранов",{className:"line2478f"});
			L.circleMarker([59.9324, 30.4393],Object.assign({color:"#e42409",u:"line4/ladozhskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Ладожская",{className:"line2381f"});
			L.circleMarker([59.851, 30.323],Object.assign({color:"#dc2e0c",u:"line2/moskovskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Московская",{className:"line2281f"});
			L.circleMarker([59.8294, 30.3755],Object.assign({color:"#d7360d",u:"line2/kupchino"},z)).addTo(map).on("click",cClk).bindTooltip("Купчино",{className:"line2204f"});
			L.circleMarker([60.0502, 30.4425],Object.assign({color:"#d23c0f",u:"line1/devyatkino"},z)).addTo(map).on("click",cClk).bindTooltip("Девяткино",{className:"line2142f"});
			L.circleMarker([59.957, 30.3555],Object.assign({color:"#c54d13",u:"line1/ploshadlenina"},z)).addTo(map).on("click",cClk).bindTooltip("Площадь Ленина",{className:"line1965f"});
			L.circleMarker([60.0025, 30.2967],Object.assign({color:"#bb5a17",u:"line2/pionerskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Пионерская",{className:"line1834f"});
			L.circleMarker([60.0514, 30.3324],Object.assign({color:"#bb5b17",u:"line2/prosvet"},z)).addTo(map).on("click",cClk).bindTooltip("Проспект Просвещения",{className:"line1828f"});
			L.circleMarker([59.9664, 30.3116],Object.assign({color:"#b46419",u:"line2/petrogradskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Петроградская",{className:"line1732f"});
			L.circleMarker([59.8503, 30.2683],Object.assign({color:"#b1681a",u:"line1/leninsky"},z)).addTo(map).on("click",cClk).bindTooltip("Ленинский Проспект",{className:"line1699f"});
			L.circleMarker([59.9426, 30.2783],Object.assign({color:"#a9731d",u:"line3/vaska"},z)).addTo(map).on("click",cClk).bindTooltip("Василеостровская",{className:"line1584f"});
			L.circleMarker([59.9074, 30.4833],Object.assign({color:"#a8741d",u:"line4/dybenko"},z)).addTo(map).on("click",cClk).bindTooltip("Улица Дыбенко",{className:"line1576f"});
			L.circleMarker([59.9199, 30.4667],Object.assign({color:"#9f8120",u:"line4/bolshevikov"},z)).addTo(map).on("click",cClk).bindTooltip("Проспект Большевиков",{className:"line1447f"});
			L.circleMarker([60.0085, 30.2586],Object.assign({color:"#9e8221",u:"line5/komendantsky"},z)).addTo(map).on("click",cClk).bindTooltip("Комендантский проспект",{className:"line1436f"});
			L.circleMarker([59.9445, 30.3601],Object.assign({color:"#9a8722",u:"line1/chernyshevskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Чернышевская",{className:"line1379f"});
			L.circleMarker([60.0346, 30.4183],Object.assign({color:"#988922",u:"line1/grazhdansky"},z)).addTo(map).on("click",cClk).bindTooltip("Гражданский проспект",{className:"line1363f"});
			L.circleMarker([59.9485, 30.235],Object.assign({color:"#968c23",u:"line3/primorskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Приморская",{className:"line1333f"});
			L.circleMarker([60.0128, 30.396],Object.assign({color:"#939024",u:"line1/akademicheskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Академическая",{className:"line1290f"});
			L.circleMarker([59.8667, 30.2613],Object.assign({color:"#8e9726",u:"line1/avtovo"},z)).addTo(map).on("click",cClk).bindTooltip("Автово",{className:"line1221f"});
			L.circleMarker([59.9012, 30.2749],Object.assign({color:"#8e9726",u:"line1/narvskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Нарвская",{className:"line1220f"});
			L.circleMarker([59.9272, 30.3205],Object.assign({color:"#8d9826",u:"line2/sennaya"},z)).addTo(map).on("click",cClk).bindTooltip("Сенная Площадь",{className:"line1207f"});
			L.circleMarker([59.9855, 30.3008],Object.assign({color:"#8b9c27",u:"line2/chernayarechka"},z)).addTo(map).on("click",cClk).bindTooltip("Черная Речка",{className:"line1176f"});
			L.circleMarker([59.9896, 30.2551],Object.assign({color:"#899e28",u:"line5/starayaderevnya"},z)).addTo(map).on("click",cClk).bindTooltip("Старая Деревня",{className:"line1155f"});
			L.circleMarker([59.9561, 30.3187],Object.assign({color:"#899e28",u:"line2/gorkovskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Горьковская",{className:"line1154f"});
			L.circleMarker([59.9072, 30.2995],Object.assign({color:"#889f28",u:"line1/baltiyskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Балтийская",{className:"line1142f"});
			L.circleMarker([60.0371, 30.3215],Object.assign({color:"#889f28",u:"line2/ozerki"},z)).addTo(map).on("click",cClk).bindTooltip("Озерки",{className:"line1142f"});
			L.circleMarker([59.934, 30.3315],Object.assign({color:"#82a72a",u:"line3/gostinka"},z)).addTo(map).on("click",cClk).bindTooltip("Гостиный двор",{className:"line1063f"});
			L.circleMarker([59.9359, 30.3146],Object.assign({color:"#7dae2c",u:"line5/admiralteyskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Адмиралтейская",{className:"line992f"});
			L.circleMarker([59.87, 30.3797],Object.assign({color:"#7caf2c",u:"line5/mezhdunarodnaya"},z)).addTo(map).on("click",cClk).bindTooltip("Международная",{className:"line982f"});
			L.circleMarker([59.8332, 30.3495],Object.assign({color:"#7ab12d",u:"line2/zvezdnaya"},z)).addTo(map).on("click",cClk).bindTooltip("Звездная",{className:"line956f"});
			L.circleMarker([59.8664, 30.3218],Object.assign({color:"#7ab22d",u:"line2/parkpobedy"},z)).addTo(map).on("click",cClk).bindTooltip("Парк Победы",{className:"line948f"});
			L.circleMarker([59.971, 30.3474],Object.assign({color:"#78b42d",u:"line1/vyborgskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Выборгская",{className:"line929f"});
			L.circleMarker([59.8773, 30.4417],Object.assign({color:"#77b52e",u:"line3/lomonosovskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Ломоносовская",{className:"line914f"});
			L.circleMarker([59.9355, 30.3269],Object.assign({color:"#77b62e",u:"line3/gostinka/gribanal"},z)).addTo(map).on("click",cClk).bindTooltip("Невский проспект-2",{className:"line911f"});
			L.circleMarker([60.0668, 30.3343],Object.assign({color:"#75b82e",u:"line2/parnas"},z)).addTo(map).on("click",cClk).bindTooltip("Парнас",{className:"line889f"});
			L.circleMarker([59.929, 30.4117],Object.assign({color:"#75b82e",u:"line4/novocherkasskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Новочеркасская",{className:"line885f"});
			L.circleMarker([59.9881, 30.2027],Object.assign({color:"#75b92e",u:"line3/begovaya"},z)).addTo(map).on("click",cClk).bindTooltip("Беговая",{className:"line882f"});
			L.circleMarker([59.8797, 30.2619],Object.assign({color:"#74b92f",u:"line1/kirovsky"},z)).addTo(map).on("click",cClk).bindTooltip("Кировский Завод",{className:"line875f"});
			L.circleMarker([59.9346, 30.3303],Object.assign({color:"#71bd30",u:"line2/nevsky/warmpipe"},z)).addTo(map).on("click",cClk).bindTooltip("Тёплая труба",{className:"line835f"});
			L.circleMarker([59.8309, 30.5001],Object.assign({color:"#70bf30",u:"line3/rybatskoe"},z)).addTo(map).on("click",cClk).bindTooltip("Рыбацкое",{className:"line815f"});
			L.circleMarker([59.9275, 30.348],Object.assign({color:"#6fc030",u:"line1/vladimirskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Владимирская",{className:"line806f"});
			L.circleMarker([59.9999, 30.3664],Object.assign({color:"#6fc130",u:"line1/muzhestva"},z)).addTo(map).on("click",cClk).bindTooltip("Площадь Мужества",{className:"line802f"});
			L.circleMarker([60.0089, 30.3709],Object.assign({color:"#6ec131",u:"line1/polytech"},z)).addTo(map).on("click",cClk).bindTooltip("Политехническая",{className:"line794f"});
			L.circleMarker([60.0167, 30.3156],Object.assign({color:"#6ec231",u:"line2/udelnaya"},z)).addTo(map).on("click",cClk).bindTooltip("Удельная",{className:"line792f"});
			L.circleMarker([59.8576, 30.3943],Object.assign({color:"#6ec231",u:"line5/prospektslavy"},z)).addTo(map).on("click",cClk).bindTooltip("Проспект Славы",{className:"line792f"});
			L.circleMarker([59.9315, 30.355],Object.assign({color:"#6dc331",u:"line3/mayakovskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Маяковская",{className:"line777f"});
			L.circleMarker([59.9848, 30.3443],Object.assign({color:"#6dc331",u:"line1/lesnaya"},z)).addTo(map).on("click",cClk).bindTooltip("Лесная",{className:"line773f"});
			L.circleMarker([59.961, 30.292],Object.assign({color:"#6bc531",u:"line5/chkalovskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Чкаловская",{className:"line756f"});
			L.circleMarker([59.8792, 30.3186],Object.assign({color:"#69c832",u:"line2/elektrosila"},z)).addTo(map).on("click",cClk).bindTooltip("Электросила",{className:"line731f"});
			L.circleMarker([59.9243, 30.3852],Object.assign({color:"#68ca33",u:"line3/alexnevskogo1"},z)).addTo(map).on("click",cClk).bindTooltip("Площадь Александра Невского-1",{className:"line707f"});
			L.circleMarker([59.8917, 30.3179],Object.assign({color:"#66cc33",u:"line2/moskovskievorota"},z)).addTo(map).on("click",cClk).bindTooltip("Московские Ворота",{className:"line689f"});
			L.circleMarker([59.8967, 30.4235],Object.assign({color:"#66cd33",u:"line3/elizarovskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Елизаровская",{className:"line678f"});
			L.circleMarker([59.9269, 30.3196],Object.assign({color:"#66cd33",u:"line4/spasskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Спасская",{className:"line678f"});
			L.circleMarker([59.8399, 30.4106],Object.assign({color:"#63d034",u:"line5/dunayskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Дунайская",{className:"line643f"});
			L.circleMarker([59.9205, 30.3297],Object.assign({color:"#5cd936",u:"line1/pushkinskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Пушкинская",{className:"line556f"});
			L.circleMarker([59.9718, 30.2594],Object.assign({color:"#5cd936",u:"line5/krestovsky"},z)).addTo(map).on("click",cClk).bindTooltip("Крестовский остров",{className:"line556f"});
			L.circleMarker([59.9207, 30.3552],Object.assign({color:"#5bdb37",u:"line4/ligovsky"},z)).addTo(map).on("click",cClk).bindTooltip("Лиговский проспект",{className:"line533f"});
			L.circleMarker([59.9148, 30.349],Object.assign({color:"#5bdb37",u:"line5/obvodny"},z)).addTo(map).on("click",cClk).bindTooltip("Обводный канал",{className:"line531f"});
			L.circleMarker([59.8652, 30.4703],Object.assign({color:"#5adc37",u:"line3/proletarskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Пролетарская",{className:"line529f"});
			L.circleMarker([59.9282, 30.3463],Object.assign({color:"#59dd37",u:"line4/dostoevskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Достоевская",{className:"line515f"});
			L.circleMarker([59.9271, 30.3184],Object.assign({color:"#59dd38",u:"line5/sadovaya"},z)).addTo(map).on("click",cClk).bindTooltip("Садовая",{className:"line512f"});
			L.circleMarker([59.9063, 30.3174],Object.assign({color:"#58df38",u:"line2/frunzenskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Фрунзенская",{className:"line495f"});
			L.circleMarker([59.9517, 30.2906],Object.assign({color:"#57e038",u:"line5/sportivnaya/upper"},z)).addTo(map).on("click",cClk).bindTooltip("Спортивная (верхний зал)",{className:"line480f"});
			L.circleMarker([59.9224, 30.3357],Object.assign({color:"#57e138",u:"line5/zvenigorodskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Звенигородская",{className:"line476f"});
			L.circleMarker([59.9517, 30.2906],Object.assign({color:"#53e53a",u:"line5/sportivnaya/travelator"},z)).addTo(map).on("click",cClk).bindTooltip("Спортивная (травелатор)",{className:"line431f"});
			L.circleMarker([59.9478, 30.2842],Object.assign({color:"#53e53a",u:"line5/sportivnaya/lower"},z)).addTo(map).on("click",cClk).bindTooltip("Спортивная (нижний зал)",{className:"line431f"});
			L.circleMarker([59.9236, 30.3833],Object.assign({color:"#4cef3c",u:"line4/alexnevskogo2"},z)).addTo(map).on("click",cClk).bindTooltip("Площадь Александра Невского-2",{className:"line336f"});
			L.circleMarker([59.8836, 30.3694],Object.assign({color:"#4cef3c",u:"line5/bukharestskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Бухарестская",{className:"line332f"});
			L.circleMarker([59.9722, 30.212],Object.assign({color:"#4af23d",u:"line3/zenit"},z)).addTo(map).on("click",cClk).bindTooltip("Зенит",{className:"line302f"});
			L.circleMarker([59.8487, 30.4577],Object.assign({color:"#47f53e",u:"line3/obukhovo"},z)).addTo(map).on("click",cClk).bindTooltip("Обухово",{className:"line272f"});
			L.circleMarker([59.82, 30.4328],Object.assign({color:"#45f83e",u:"line5/shushary"},z)).addTo(map).on("click",cClk).bindTooltip("Шушары",{className:"line241f"});
			L.circleMarker([59.896, 30.3585],Object.assign({color:"#40ff40",u:"line5/volkovskaya"},z)).addTo(map).on("click",cClk).bindTooltip("Волковская",{className:"line172f"});
		`.split(';');

		var items = [];
		var item = [];
		stations.forEach(station => {
			var tmpParse = station.replace('"},z)).addTo(map).on("click",cClk).bindTooltip("', '|').replace('L.circleMarker([', '').replace('],Object.assign({color:"', '|').replace('",u:"', '|').replace('",{className:"line', '|').replace('f"})', '').replace(', ', '|');
			if(tmpParse.length > 5){
	//			console.log(tmpParse[0].trim().replace('L.circleMarker([', ''), tmpParse[1].trim());
			var tmpItem = tmpParse.trim().split('|');
			item = [];
			item.lat     = tmpItem[0];
			item.lon     = tmpItem[1];
			item.color   = tmpItem[2];
			item.name    = tmpItem[3];
			item.tooltip = tmpItem[4];
			item.traffic = tmpItem[5];
			//console.log(item);
			items.push(item);
			}
		});
	return items;
	}

	styleFunc(feature, resolution){
		var props = feature.getProperties();
		var name = feature.get('name');
		var style = [];
		props.stroke = '#000';
		
		var scale = 1/Math.pow(resolution, 1/6);
		var zIndex = 100;
		if (hoverSelectedName === name){
			scale *= 1.5;
			zIndex = 10000;
		}

		var square = new ol.style.Style({
			image: new ol.style.RegularShape({
				fill: new ol.style.Fill({
							color: props.color,
						}),
				stroke: new ol.style.Stroke({
							//color: 'rgba(0,0,0,0.5)',
							color: props.stroke,
							width: 1,
						}),
				points: 4,
				radius: 9,
				angle: Math.PI / 4,
				scale: scale,
			}),
			zIndex: zIndex,
		});

		style = square;
		return style;
	}

	ping(){
		//console.log('metro ping!');
	}



//======================== /* MOUSE EVENTS */ =========================

	hoverUnset(){
		if (hoverSelectedName !== '') {
			hoverSelectedName = '';
			hoverSelectedFeature.setStyle(this.styleFunc);
			hoverSelectedFeature = null;
		}
	}

	hoverFunc(feature){
		var name = feature.get('name');
		hoverSelectedName = name;
		hoverSelectedFeature = feature;
		hoverSelectedFeature.setStyle(this.styleFunc);
	}


	clickUnset(){
//		leftContainer.style.display="none";
		targetDiv.style.display="none";
		// if(clickSelected !== ''){	//???
			// var feature = this.getFeatureByName(clickSelected);
			// clickSelected = '';
			// feature.setStyle(this.styleFunc);
		// }
	}

	clickFunc(feature){
		var name = feature.get('name');

		var coordinate = feature.getGeometry().getCoordinates();
		popupContent.innerHTML = this.getLoadingHtml();
		this.overlay.setPosition(coordinate);
		targetDiv.style.display="block";

		popupContent.innerHTML = this.getMetroHtml(feature);
		// clickSelected = name;	//???
		feature.setStyle(this.styleFunc);

//		leftContent.innerHTML = getLoadingHtml();
//		leftContainer.style.display="flex";
//		leftContent.innerHTML = await this.getAvitoInfo(name);

//		targetDiv.style.display="none";
//		setDescriptionEvents();

		// var radios = document.querySelectorAll('input[type=radio][class="types_btn"]');
		// radios.forEach(el => el.addEventListener('change', event => {
			// this.changeHandler(event);
		// }));
	}
//======================== /* MOUSE EVENTS */ =========================

	getMetroHtml(feature){
		var props = feature.getProperties();
//console.log(props);
		var html = '<div>';
		html += '<span style="white-space:nowrap;">'+props.tooltip+'</span><br /><span style="white-space:nowrap;">Трафик: <b>'+props.traffic+'</b> тыс чел/месяц</span>';
		html += '</div>';
		
		return html;
	}

}
